<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    id?: string;
    type?: string;
    message?: string;
    dismissible?: boolean;
    show?: boolean;
  }>(),
  {
    type: 'info',
    dismissible: false,
    show: false,
  },
);

const emit = defineEmits<{
  dismissed: [payload: { id: string | undefined }];
}>();

const onDismissed = () => {
  emit('dismissed', { id: props.id });
};
</script>

<template>
  <div
    v-if="show"
    :id="id"
    class="alert"
    :class="[`alert-${type}`, { 'alert-dismissible fade show': dismissible }]"
    role="alert"
  >
    {{ message }}
    <slot />
    <button
      v-if="dismissible"
      type="button"
      class="close"
      aria-label="Close"
      @click="onDismissed"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

